import { homedir } from "node:os";
import { join, resolve } from "node:path";
import type { WakeLoopPathResolutionInput } from "./paths";
import {
  resolveDefaultWakeLoopHomeDirname,
  resolveWakeLoopRootDir,
} from "./paths";

const PUBLISHED_PRODUCTION_WAKELOOP_ROOT = normalizeComparablePath(
  join(homedir(), resolveDefaultWakeLoopHomeDirname("prod"))
);

export function assertNoPublishedProductionMutationDuringTests(
  pathInput: WakeLoopPathResolutionInput,
  targetName: string
): void {
  if (!isTestProcess(pathInput)) {
    return;
  }
  if (!isPublishedProductionWakeLoopRoot(pathInput)) {
    return;
  }
  throw new Error(
    [
      `Refusing to mutate ${targetName} in the published production lane during tests.`,
      "Set WAKELOOP_HOME to a fresh temporary directory, or run the validation through wakeloop-dev or wakeloop-canary.",
    ].join(" ")
  );
}

export function isPublishedProductionWakeLoopRoot(
  pathInput: WakeLoopPathResolutionInput
): boolean {
  return (
    normalizeComparablePath(resolveWakeLoopRootDir(pathInput)) ===
    PUBLISHED_PRODUCTION_WAKELOOP_ROOT
  );
}

export function isTestProcess(
  pathInput: WakeLoopPathResolutionInput = {}
): boolean {
  const env = pathInput.env ?? process.env;
  const argv = pathInput.argv ?? process.argv;
  return (
    env.NODE_ENV === "test" ||
    env.VITEST === "true" ||
    typeof env.VITEST_WORKER_ID === "string" ||
    typeof env.JEST_WORKER_ID === "string" ||
    argv.some((arg) => arg.includes("vitest"))
  );
}

function normalizeComparablePath(path: string): string {
  const normalized = resolve(path);
  return process.platform === "win32" ? normalized.toLowerCase() : normalized;
}
